<template>
	<q-layout-footer>
		<q-toolbar>
			<q-toolbar-title class="widget-footer">
				<template slot="subtitle" v-if="showPoweredBy">
					Powered by<br /> CollegeTransfer.net
				</template>
			</q-toolbar-title>

			<!--
				<q-btn flat  icon="mail" label="Request More Info" />
			-->
		</q-toolbar>
	</q-layout-footer>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import config from '@/models/services/config';

@Component
export default class LayoutFooter extends Vue {
	public get showPoweredBy() {
		return config.ShowPoweredBy;
	}
}
</script>

<style>
	@media screen and (max-width: 373px) {
		.q-toolbar-title.widget-footer .q-toolbar-subtitle {
			font-size: 50%;
			text-overflow: initial;
			white-space: initial;
			overflow: visible;
		}
	}
</style>